import { Grid } from '@mui/material'

import { EmailFields } from '@/components/auto-report-dialog/email-fields.tsx'
import { CheckboxControl, RadioGroupControl } from '@/components/form'
import { AutoReportRequestFormState } from '@/components'

export const AddEmailsWindow = () => {
  return (
    <>
      <EmailFields />
      <Grid item xs={12}>
        <RadioGroupControl<AutoReportRequestFormState>
          name="formatReport"
          row
          label="Формат отчёта"
          items={[
            { title: '.xlsx', value: 'xlsx' },
            { title: '.csv', value: 'csv' },
          ]}
        />
      </Grid>
      <Grid container item flexDirection="row" spacing={2}>
        <Grid item>
          <CheckboxControl<AutoReportRequestFormState> name="monthly" label="Ежемесячный" />
        </Grid>
        <Grid item>
          <CheckboxControl<AutoReportRequestFormState> name="daily" label="Ежедневный" />
        </Grid>
      </Grid>
    </>
  )
}
